import CalculationDriverSalary from "components/calculationDriverSalary";
import CalculationSalariesShow from "components/calculationSalaries/show";
import ClassificationTypes from "components/classificationTypes";
import DocumentTemplates from "components/documentTemplates";
import DocumentTracking from "components/documentTracking";
import Expenses from "components/expenses";
import FinancesDocuments from "components/finances/documents";
import FinancesDocumentsShow from "components/finances/documents/show";
import Registries from "components/finances/registries";
import UniversalTransferDocuments from "components/finances/universalTransferDocuments";
import Show from "components/reports/show";
import TripSheets from "components/tripSheets";
import { documentBusinessTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { paramsObject } from "helpers/system";
import React from "react";
import { Route, Switch } from "react-router-dom";
import * as source from "sources/books/reports";
import List from "./list";

export default function Finances(props) {
    const { location, history } = props;
    const back = () => history.push(paths.finances);

    return (
        <div className="page-content">
            <Switch location={location}>
                <Route
                    exact
                    path={paths.financesShow("LogisticSalaryReport")}
                    render={(rest) => <CalculationSalariesShow {...rest} back={back} title="Расчет ЗП логистов" />}
                />
                <Route
                    exact
                    path={paths.financesShow("DriverSalaryReport")}
                    render={(rest) => <CalculationDriverSalary {...rest} back={back} title="Расчет ЗП водителей" />}
                />
                <Route path={paths.documentTemplates} component={DocumentTemplates} />
                <Route path={paths.classificationTypes} component={ClassificationTypes} />
                <Route path={paths.documentTracking} component={DocumentTracking} />
                <Route path={paths.expenses} component={Expenses} />
                <Route path={paths.financesDocumentsShow(":id")} component={FinancesDocumentsShow} />
                <Route path={paths.universalTransferDocuments} component={UniversalTransferDocuments} />
                <Route path={paths.registries} component={Registries} />
                <Route path={paths.tripSheets} component={TripSheets} />
                <Route
                    path={paths.financesContract}
                    component={FinancesDocuments[documentBusinessTypesEnum.Contract]}
                />
                <Route path={paths.financesInvoice} component={FinancesDocuments[documentBusinessTypesEnum.Invoice]} />
                <Route
                    path={paths.financesAcceptanceCertificate}
                    component={FinancesDocuments[documentBusinessTypesEnum.AcceptanceCertificate]}
                />
                <Route
                    path={paths.financesAcceptanceCertificateInvoice}
                    component={FinancesDocuments[documentBusinessTypesEnum.TaxInvoice]}
                />
                <Route
                    path={paths.financesShow(":id")}
                    render={(props) => {
                        const id = props.match.params.id;
                        const { taskKey, regionId, regionType } = paramsObject(props.location.search);
                        return (
                            <Show
                                {...props}
                                id={id}
                                taskKey={taskKey}
                                regionId={regionId}
                                regionType={regionType}
                                transition="full"
                                source={source}
                                back={back}
                            />
                        );
                    }}
                />
                <Route path={paths.finances} component={List} />
            </Switch>
        </div>
    );
}
